import * as React from 'react'

import Group from '../tabs/registry/views/Group'
import { TableProvider } from '../context/TableContext'
import { RouteComponentProps } from '@/app/navigation/withRouter'

interface RouteParams {
  companyId: string
}

export const DriverGroupTimesheetPage: React.FC<
  RouteComponentProps<RouteParams>
> = ({ match }) => {
  const { companyId } = match.params

  return (
    <section className="tw-flex tw-h-full tw-w-full tw-flex-col">
      <TableProvider>
        <Group companyId={companyId} />
      </TableProvider>
    </section>
  )
}
